import React from 'react'

const SidebarFooter = () => {
    return (
        <div className='mt-15 h-100'></div>
    )
}

export default SidebarFooter